import { ArtifactsViewerData } from "@/hooks/useArtifactsViewerData";
import { MediaEditorItem } from "@/types/mediaArtifact";
import { MediaArtifactItem } from "./MediaArtifact/MediaArtifactItem";
import { Section } from "./Section";

type ReferenceImageSectionProps = ArtifactsViewerData["referenceImage"] & {
  canEdit: boolean;
  onItemClick: (item: MediaEditorItem, index: number) => void;
  items: MediaEditorItem[];
};

export function ReferenceImageSection(props: ReferenceImageSectionProps) {
  const { id, items, data, visible, title, canEdit, onItemClick } = props;

  const mediaEditorItems = items;

  if (!visible) {
    return null;
  }

  return (
    <Section id={id} title={title}>
      <div className={`artifacts-grid grid-cols-3_4`}>
        {mediaEditorItems.map((item, index) => (
          <MediaArtifactItem
            key={
              item.current.id || item.current.filePath || `ref-image-${index}`
            }
            item={item}
            index={index}
            canEdit={canEdit}
            mediaType={item.mediaType}
            onClick={() => onItemClick(item, index)}
            titleText={data.images[index]?.id}
          />
        ))}
      </div>
    </Section>
  );
}
